import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { GoogleAnalyticsService } from '../app/services/google-analytics.service';

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'Inforida';
  public isCollapsed = true;
  headerMenuItems = [
    {
      name: 'Home',
      state: '/home',
    },
    {
      name: 'Services',
      state: '/features',
    },
    {
      name: 'Login',
      state: '/user/login',
    },
  ];

  constructor(
    public router: Router,
    public gaService: GoogleAnalyticsService
  ) {}

  ngOnInit() {}

  submitEvent(
    name: string,
    category: string,
    action: string,
    label?: string,
    value?: number
  ) {
    this.gaService.eventEmitter(name, category, action, label, value);
  }
}
